/**
 * Format a distance in meters for display.
 * Returns value in meters if < 1 km, otherwise in km with max 2 decimals.
 * @param {number} meters - Distance in meters
 * @param {function} t - i18n translate function
 * @returns {string} Translated string (e.g. "250 m" or "1.5 km")
 */
export const formatDistanceString = (meters, t) => {
  if (meters < 1000) {
    const value = meters.toFixed(1).replace(/\.?0+$/, "");
    return t("risksMap.floodDistance.meters", { value });
  }
  const value = (meters / 1000).toFixed(2).replace(/\.?0+$/, "");
  return t("risksMap.floodDistance.km", { value });
};

export const getWaterFeatureName = (feature) =>
  feature?.properties?.nametext || feature?.properties?.nametxtint || "Unknown";

export const getNearbyWaterFeature = ({
  map,
  point,
  activeRisk,
  riversLayerId,
  lakesLayerId,
  riversProximity = 10,
  disableRivers = false,
}) => {
  if (!map || activeRisk !== "flood") {
    return null;
  }

  if (disableRivers === false) {
    const bbox = [
      [point.x - riversProximity, point.y - riversProximity],
      [point.x + riversProximity, point.y + riversProximity],
    ];

    const riverFeatures = map.queryRenderedFeatures(bbox, {
      layers: [riversLayerId],
    });

    if (riverFeatures.length > 0) {
      return riverFeatures[0];
    }
  }

  const lakeFeatures = map.queryRenderedFeatures(point, {
    layers: [lakesLayerId],
  });

  return lakeFeatures[0] || null;
};
